import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'
import _imports_1 from '@/app/ui/assets/svg/bg-must-sti-booking.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-right-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7b47df93")

_pushScopeId("data-v-7b47df93")
const _hoisted_1 = { class: "pt-2 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full pr-5 sm:pr-0" }
const _hoisted_2 = { class: "flex-col" }
const _hoisted_3 = { class: "flex justify-end items-center " }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-14px font-montserrat font-normal text-gray-500" }, " Data diupdate setiap 10 menit ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0
}, null, -1)
const _hoisted_6 = { class: "flex space-x-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "absolute top-0 right-0 bottom-0 object-cover h-full",
  src: _imports_1
}, null, -1)
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "text-24px font-montserrat font-bold mt-5 pt-2" }, " STT ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-16px font-monstserrat font-bold" }, " Harus STI saat ini! "),
  /*#__PURE__*/_createVNode("img", {
    class: "ml-2",
    src: _imports_2
  })
], -1)
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-24px font-montserrat font-bold mt-5 pt-2" }, " STT ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-16px font-monstserrat font-bold" }, " Telat STI, proses sekarang! "),
  /*#__PURE__*/_createVNode("img", {
    class: "ml-2",
    src: _imports_2
  })
], -1)
const _hoisted_14 = { class: "flex flex-col sm:flex sm:flex-row gap-x-4" }
const _hoisted_15 = { class: "font-semibold text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_16 = { class: "flex flex-row space-x-4" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 5 }
const _hoisted_20 = {
  key: 2,
  class: "overflow-auto"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_Search = _resolveComponent("Search")!
  const _component_advanced_filter = _resolveComponent("advanced-filter")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalErrorBalance = _resolveComponent("ModalErrorBalance")!
  const _component_DetailRejectPopup = _resolveComponent("DetailRejectPopup")!
  const _component_ModalInstantBoookingConfirmation = _resolveComponent("ModalInstantBoookingConfirmation")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createVNode("div", {
            class: "text-14px font-montserrat font-normal text-red-500 ml-1 cursor-pointer underline",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRefreshSTISummary && _ctx.onRefreshSTISummary(...args)))
          }, " Refresh ")
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            class: "flex items-center justify-between background-gradient-red px-3 py-2.5 text-white rounded-lg shadow-lg w-full relative cursor-pointer border border-red-lp-100",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoNeedToStiPage(true, false)))
          }, [
            _hoisted_7,
            _withDirectives(_createVNode(_component_skeleton, {
              width: "250px",
              height: "62px"
            }, null, 512), [
              [_vShow, _ctx.isLoadingSTTSummary]
            ]),
            _withDirectives(_createVNode("div", _hoisted_8, [
              _createVNode("div", {
                class: ["font-montserrat font-bold line-height-075", String(_ctx.STISTTDueSummaryData.totalNow).length >= 10 ? 'text-45px' : 'text-60px']
              }, _toDisplayString(_ctx.STISTTDueSummaryData.totalNow), 3),
              _hoisted_9
            ], 512), [
              [_vShow, !_ctx.isLoadingSTTSummary]
            ]),
            _hoisted_10
          ]),
          _createVNode("div", {
            class: "flex items-center justify-between background-gradient-yellow text-white p-4 rounded-md shadow-md w-full cursor-pointer",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotoNeedToStiPage(false, true)))
          }, [
            _withDirectives(_createVNode(_component_skeleton, {
              width: "250px",
              height: "62px"
            }, null, 512), [
              [_vShow, _ctx.isLoadingSTTSummary]
            ]),
            _withDirectives(_createVNode("div", _hoisted_11, [
              _createVNode("div", {
                class: ["font-montserrat font-bold line-height-075", String(_ctx.STISTTDueSummaryData.totalOverdue).length >= 7 ? 'text-45px' : 'text-60px']
              }, _toDisplayString(_ctx.STISTTDueSummaryData.totalOverdue), 3),
              _hoisted_12
            ], 512), [
              [_vShow, !_ctx.isLoadingSTTSummary]
            ]),
            _hoisted_13
          ])
        ])
      ], 512), [
        [_vShow, _ctx.isAccountPOS]
      ]),
      _withDirectives(_createVNode("div", {
        class: "fixed right-0 h-full z-20",
        style: 
        `background-color:rgba(0,0,0,0.3); top: 9rem; width: calc(100% - ${
          _ctx.isAdvancedFilterOpened && _ctx.isCollapseSidebar ? `4px` : `24px`
        });`
      
      }, null, 4), [
        [_vShow, _ctx.isAdvancedFilterOpened]
      ]),
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$route?.meta.name), 1),
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              class: "w-300px mb-1",
              placeholder: _ctx.$t('bookingShipment.list.searchStt')
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
            (_ctx.isAbleToAdvanceFilter)
              ? (_openBlock(), _createBlock(_component_advanced_filter, {
                  key: 0,
                  isAddedStatus: _ctx.isPosChild || _ctx.isInternal,
                  "model-value": _ctx.advancedFilterData,
                  isPeriode: true,
                  isOriginDestination: true,
                  isCountryScoped: true,
                  isClientPartner: true,
                  isNestedStatus: true,
                  isProduct: "",
                  isCOD: _ctx.accountIsNonForeign,
                  isPAD: _ctx.isEnableCodBooking,
                  isDFOD: "",
                  addSumFilter: 
            _ctx.advancedFilterData.DFOD ? 1 + _ctx.addSumFilter : 0 + _ctx.addSumFilter
          ,
                  isAsuransi: true,
                  isDisabled: false,
                  clientPartnerPlaceholder: 
            _ctx.$t('bookingShipment.placeholderSelect.SelectclientPartner')
          ,
                  titleProductCustom: _ctx.$t('bookingShipment.list.filter.serviceType'),
                  isPhoneNumber: "",
                  onChangeFilter: _ctx.onChangeAdvancedFilter,
                  onResetFilter: _ctx.onResetAdvancedFilter,
                  isButtonApply: "",
                  customSenderPhone: _ctx.getPhoneNumber,
                  customMaxHeight: "50vh",
                  customDropdownWidth: "w-377px",
                  isFilterOnlyInterpack: !_ctx.accountIsNonForeign
                }, null, 8, ["isAddedStatus", "model-value", "isCOD", "isPAD", "addSumFilter", "clientPartnerPlaceholder", "titleProductCustom", "onChangeFilter", "onResetFilter", "customSenderPhone", "isFilterOnlyInterpack"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_16, [
            (_ctx.permissionList.total === 1)
              ? (_openBlock(), _createBlock(_component_lp_button, {
                  key: 0,
                  class: "mr-2",
                  onClick: _ctx.permissionList.action,
                  title: _ctx.permissionList.title,
                  textColor: "white",
                  disabled: !_ctx.validationAccount
                }, null, 8, ["onClick", "title", "disabled"]))
              : (_ctx.permissionList.total > 1)
                ? (_openBlock(), _createBlock(_component_lp_button, {
                    key: 1,
                    class: "mr-2",
                    onClick: _cache[4] || (_cache[4] = 
            event => {
              _ctx.hitGtmBookingClicked();
              _ctx.togglePanel(event);
            }
          ),
                    title: _ctx.$t('bookingShipment.list.createBooking'),
                    textColor: "white",
                    icon: _ctx.panelVisible ? 'chevron-up-white' : 'chevron-down-white',
                    disabled: !_ctx.validationAccount
                  }, null, 8, ["title", "icon", "disabled"]))
                : _createCommentVNode("", true),
            _createVNode(_component_OverlayPanel, {
              ref: "op",
              appendTo: "body",
              style: {"width":"auto"}
            }, {
              default: _withId(() => [
                (_ctx.isCreateManualAble)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = 
              event => {
                _ctx.goToCreate();
                _ctx.togglePanel(event);
              }
            ),
                      class: "w-60",
                      flat: "",
                      dense: "",
                      iconLeft: "document-add",
                      title: _ctx.$t('bookingShipment.list.bookingRetail')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                (_ctx.isCreateManualAble)
                  ? (_openBlock(), _createBlock("hr", _hoisted_17))
                  : _createCommentVNode("", true),
                (_ctx.isCreateForCorporateAble)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 2,
                      onClick: _ctx.goToCreateClientBook,
                      class: "w-60",
                      flat: "",
                      dense: "",
                      iconLeft: "booking-client",
                      title: _ctx.$t('bookingShipment.list.bookingClient')
                    }, null, 8, ["onClick", "title"]))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateShipmentId)
                  ? (_openBlock(), _createBlock("hr", _hoisted_18))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateShipmentId)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 4,
                      onClick: _ctx.goToCreateShipmentBook,
                      class: "w-60",
                      flat: "",
                      dense: "",
                      customClass: "text-left",
                      iconLeft: "scan-qrcode",
                      title: _ctx.$t('bookingShipment.list.bookingAppMarketplace')
                    }, null, 8, ["onClick", "title"]))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateInstantBooking)
                  ? (_openBlock(), _createBlock("hr", _hoisted_19))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateInstantBooking)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 6,
                      onClick: _cache[6] || (_cache[6] = 
              event => {
                _ctx.tncModal = true;
                _ctx.togglePanel(event);
              }
            ),
                      class: "w-60",
                      flat: "",
                      dense: "",
                      iconLeft: "instant-booking",
                      title: _ctx.$t('bookingShipment.list.bookingInstant')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _: 1
      }),
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.onRequest
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_ctx.shipmentBooking.length === 0 && _ctx.firstRequest && !_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              data: "data Booking"
            }))
          : (_openBlock(), _createBlock("div", _hoisted_20, [
              _createVNode(_component_TableV2, {
                class: "my-2",
                columns: _ctx.columns,
                data: _ctx.shipmentBooking,
                loading: _ctx.isLoading,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => (_ctx.pagination = $event)),
                onRequest: _ctx.onRequest,
                groupOptions: _ctx.actionGroupOptions,
                onClick: _ctx.goToDetail,
                isDetailAble: _ctx.isDetailAble,
                groupAction: true,
                isRightFreeze: true,
                totalColumnFreeze: 1,
                "delete-tooltip": "Batalkan Booking",
                onDeleteItem: _ctx.onOpenPopupCancelBooking,
                isPinnedScrollBottom: "",
                pinnedSubstractHeight: _ctx.isAccountPOS ? '420px' : '300px',
                paginationStyle: _ctx.paginationStyle
              }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "groupOptions", "onClick", "isDetailAble", "onDeleteItem", "pinnedSubstractHeight", "paginationStyle"])
            ]))
    ]),
    (_ctx.balanceUnderLimit)
      ? (_openBlock(), _createBlock(_component_ModalErrorBalance, {
          key: 0,
          modelValue: _ctx.balanceUnderLimit,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.balanceUnderLimit = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.isRejectPopup)
      ? (_openBlock(), _createBlock(_component_DetailRejectPopup, {
          key: 1,
          "is-detail": true,
          isShow: _ctx.isRejectPopup,
          "onUpdate:isShow": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isRejectPopup = $event)),
          sttNumber: _ctx.sttNumberSelected,
          onSuccess: _ctx.onRequest
        }, null, 8, ["isShow", "sttNumber", "onSuccess"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalInstantBoookingConfirmation, {
      isOpen: _ctx.tncModal,
      onClose: _ctx.onCloseTncModal,
      onAction: _ctx.goToInstantBooking
    }, null, 8, ["isOpen", "onClose", "onAction"])
  ], 64))
})